import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "form-check" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  class: "form-check-label",
  for: "no_payment"
}
const _hoisted_6 = { class: "form-check" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  class: "form-check-label",
  for: "HAS_PAYMENT"
}
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  class: "form-check-label",
  for: "invalid_sum"
}
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  class: "form-check-label",
  for: "NO_PAYMENT"
}
const _hoisted_17 = {
  key: 0,
  class: "form-check"
}
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  class: "form-check-label",
  for: "WAITING_CONFIRMATION"
}
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  class: "form-check-label",
  for: "INVALID_REQUISITES"
}
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  class: "form-check-label",
  for: "PAYOUT_BLACKLIST"
}
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  class: "form-check-label",
  for: "UNABLE_TO_PAY_OUT_ON_REQ"
}
const _hoisted_29 = {
  key: 1,
  class: "form-check"
}
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  class: "form-check-label",
  for: "PART_PAYOUT"
}
const _hoisted_32 = {
  key: 2,
  class: "row"
}
const _hoisted_33 = {
  for: "amount",
  class: "col-sm-4 col-form-label text-capitalize-first pe-2"
}
const _hoisted_34 = { class: "col-sm-4" }
const _hoisted_35 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_36 = { class: "row mb-3" }
const _hoisted_37 = { class: "col-sm-12" }
const _hoisted_38 = { class: "p-0 m-0" }
const _hoisted_39 = { class: "p-0 m-0" }
const _hoisted_40 = { class: "col-sm-12" }
const _hoisted_41 = { class: "me-2" }
const _hoisted_42 = {
  key: 0,
  class: "spinner-border",
  role: "status",
  style: {"zoom":"0.5"}
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.modal?.title,
    modelValue: _ctx.modal !== null,
    "footer-class": "d-flex justify-content-between",
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ($event === false && (_ctx.modal = null)))
  }, {
    default: _withCtx(() => [
      (_ctx.modal?.direction === _ctx.Direction.PAY_IN)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.reason) = $event)),
                  value: _ctx.DisputeReason.NO_PAYMENT,
                  type: "radio",
                  name: "reason",
                  id: "no_payment"
                }, null, 8, _hoisted_4), [
                  [_vModelRadio, _ctx.form.reason]
                ]),
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.DisputeReason.NO_PAYMENT}`)), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.reason) = $event)),
                  value: _ctx.DisputeReason.HAS_PAYMENT,
                  type: "radio",
                  name: "reason",
                  id: "HAS_PAYMENT"
                }, null, 8, _hoisted_7), [
                  [_vModelRadio, _ctx.form.reason]
                ]),
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.DisputeReason.HAS_PAYMENT}`)), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.reason) = $event)),
                  value: _ctx.DisputeReason.INVALID_SUM,
                  type: "radio",
                  name: "reason",
                  id: "invalid_sum"
                }, null, 8, _hoisted_10), [
                  [_vModelRadio, _ctx.form.reason]
                ]),
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.DisputeReason.INVALID_SUM}`)), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.modal?.direction === _ctx.Direction.PAY_OUT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.reason) = $event)),
                  value: _ctx.DisputeReason.NO_PAYMENT,
                  type: "radio",
                  name: "reason",
                  id: "NO_PAYMENT"
                }, null, 8, _hoisted_15), [
                  [_vModelRadio, _ctx.form.reason]
                ]),
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.DisputeReason.NO_PAYMENT}_out`)), 1)
              ]),
              (_ctx.modal?.deal.status !== _ctx.DealStatus.DISPUTE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.reason) = $event)),
                      value: _ctx.DisputeReason.WAITING_CONFIRMATION,
                      type: "radio",
                      name: "reason",
                      id: "WAITING_CONFIRMATION"
                    }, null, 8, _hoisted_18), [
                      [_vModelRadio, _ctx.form.reason]
                    ]),
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.DisputeReason.WAITING_CONFIRMATION}`)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.reason) = $event)),
                  value: _ctx.DisputeReason.INVALID_REQUISITES,
                  type: "radio",
                  name: "reason",
                  id: "INVALID_REQUISITES"
                }, null, 8, _hoisted_21), [
                  [_vModelRadio, _ctx.form.reason]
                ]),
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.DisputeReason.INVALID_REQUISITES}`)), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.reason) = $event)),
                  value: _ctx.DisputeReason.PAYOUT_BLACKLIST,
                  type: "radio",
                  name: "reason",
                  id: "PAYOUT_BLACKLIST"
                }, null, 8, _hoisted_24), [
                  [_vModelRadio, _ctx.form.reason]
                ]),
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.DisputeReason.PAYOUT_BLACKLIST}`)), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.reason) = $event)),
                  value: _ctx.DisputeReason.UNABLE_TO_PAY_OUT_ON_REQ,
                  type: "radio",
                  name: "reason",
                  id: "UNABLE_TO_PAY_OUT_ON_REQ"
                }, null, 8, _hoisted_27), [
                  [_vModelRadio, _ctx.form.reason]
                ]),
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.DisputeReason.UNABLE_TO_PAY_OUT_ON_REQ}`)), 1)
              ]),
              (_ctx.modal?.deal.status !== _ctx.DealStatus.DISPUTE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.reason) = $event)),
                      value: _ctx.DisputeReason.PART_PAYOUT,
                      type: "radio",
                      name: "reason",
                      id: "PART_PAYOUT"
                    }, null, 8, _hoisted_30), [
                      [_vModelRadio, _ctx.form.reason]
                    ]),
                    _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.DisputeReason.PART_PAYOUT}`)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      ([_ctx.DisputeReason.INVALID_SUM, _ctx.DisputeReason.PART_PAYOUT].includes(_ctx.form.reason))
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.helper.trans("labels.sum")), 1),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.getErrors(`disputeReasonData.amount`)
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.amount) = $event)),
                    class: _normalizeClass([parentProps.class, "form-control"]),
                    "data-maska": "9.##",
                    "data-maska-tokens": "9:[0-9]:multiple",
                    type: "text",
                    id: "amount"
                  }, null, 2), [
                    [_vModelText, _ctx.form.amount],
                    [_directive_maska]
                  ])
                ]),
                _: 1
              }, 8, ["errors"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.DisputeReason.PART_PAYOUT === _ctx.form.reason || _ctx.modal?.direction === _ctx.Direction.PAY_IN)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                (_ctx.modal?.direction === _ctx.Direction.PAY_IN)
                  ? (_openBlock(), _createElementBlock("div", _mergeProps({
                      key: 0,
                      style: {"cursor":"pointer","border":"1px dashed"}
                    }, _ctx.payInDropzone.getRootProps(), { class: "payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center" }), [
                      _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.payInDropzone.getInputProps())), null, 16),
                      _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.helper.trans('labels.payout_upload_files')), 1)
                    ], 16))
                  : (_openBlock(), _createElementBlock("div", _mergeProps({
                      key: 1,
                      style: {"cursor":"pointer","border":"1px dashed"}
                    }, _ctx.dropzone.getRootProps(), { class: "payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center" }), [
                      _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
                      _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.helper.trans('labels.payout_upload_files')), 1)
                    ], 16))
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileAttachments, (fileAttachment) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row mb-2 ms-2",
                key: fileAttachment.id
              }, [
                _createElementVNode("div", _hoisted_40, [
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)),
                  _cache[16] || (_cache[16] = _createTextVNode()),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(fileAttachment.file.name), 1),
                  (fileAttachment.error === null && fileAttachment.attachment === null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[13] || (_cache[13] = [
                        _createElementVNode("span", { class: "visually-hidden" }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.removeFile(fileAttachment)), ["prevent"])
                      }, _cache[14] || (_cache[14] = [
                        _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                      ]), 8, _hoisted_43)),
                  _createElementVNode("div", null, [
                    (fileAttachment.error !== null)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(fileAttachment.error), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.modal = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.modal?.cancelTitle ?? _ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onOkClick())),
            class: "btn btn-outline-danger btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.modal?.okTitle ?? _ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}